<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-12 text-center" style="overflow: hidden !important">
        <button
          v-if="iconMode && address == null"
          type="button"
          class="netpa-dropzone"
          :class="{ 'is-selected': selectedName }"
          @click="clickUploader(Idu)"
        >
          <i
            :class="selectedName ? 'fas fa-file-alt' : 'fas fa-cloud-upload-alt'"
            aria-hidden="true"
          ></i>
          <span class="netpa-dropzone__text" dir="auto">
            {{ selectedName || "برای انتخاب فایل کلیک کنید" }}
          </span>
        </button>
        <img
          v-else-if="address == null"
          @click="clickUploader(Idu)"
          class="w-100 Pointer"
          src="/Image/OHUploader.png"
        />
        <img
          v-else
          @click="clickUploader(Idu)"
          style="height: 18vh"
          :src="address"
        />
        <input
          @change="onFileChange"
          :id="Idu"
          type="file"
          class="d-none"
        />
      </div>
      <div class="col-12">
        <div class="row">
          <div class="col-12 p-3 text-center font-weight-bold">
            {{ title }}
            <i
              v-if="address != null"
              title="حذف فایل"
              class="fas fa-trash mx-2 text-danger float-left Pointer"
              @click="DeleteImage(attachId)"
            ></i>
            <a
              v-if="address != null"
              class="mx-2"
              :download="base64.filename"
              title="دانلود فایل"
              :href="'data:application/octet-stream;base64,' + base64.binary"
            >
              <i class="fas fa-download text-success float-left Pointer"></i>
            </a>
          </div>
        </div>
        <div v-if="whithName" class="row">
          <div class="col-12">
            <input
              type="text"
              style="font-size: 12px !important"
              placeholder="نام فایل"
              v-model="FileName"
              class="form-control"
            />
          </div>

          <div class="col-12">
            <slot name="uploaderCombo"> </slot>
          </div>

          <div class="col-12 mt-2">
            <button @click="uploadFIle(Idu)" class="btn btn-primary w-100">
              بارگذاری
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: [
    "Idu",
    "attachId",
    "address",
    "grp",
    "MasterId",
    "title",
    "base64",
    "TableName",
    "whithName",
    "iconMode",
  ],
  data() {
    return {
      FileName: "",
      selectedName: "",
    };
  },
  methods: {
    onFileChange(e) {
      const file = e.target.files && e.target.files[0];
      this.selectedName = file ? file.name : "";
      if (!this.whithName) this.uploadFIle(this.Idu);
    },
    clickUploader(Id) {
      document.getElementById(Id).click();
    },
    uploadFIle(Id, e) {
      this.loadingRender = true;
      const input = document.getElementById(Id);
      if (input.files && input.files[0]) {
        var file = input.files[0];
        if (file.size > 5 * 1024 * 1024) {
          this.$mySweetDefaultTost(
            "هشدار",
            "حجم فایل ارسالی باید کمتر از 5 مگابایت باشد",
            "warning",
            2000,
          );
          input.files = null;
        } else {
          if (this.CheckExtension(file.name)) {
            this.SendToApi(file);
          } else {
            this.$mySweetDefaultTost(
              "هشدار",
              "فرمت فایل پشتیبانی نمیشود!",
              "warning",
              2000,
            );
            input.files = null;
          }
        }
      }
    },
    SendToApi(file) {
      const formData = new FormData();
      formData.append("Id", this.attachId ? this.attachId : 11);
      formData.append("MasterId", this.MasterId);
      formData.append("wwwtblcomboidgrp328", Number(this.grp));
      formData.append("Filename", this.FileName);
      formData.append("Filepath", "");
      formData.append(
        "TableName",
        this.TableName ? this.TableName : "wwwtblaza",
      );

      formData.append("CustCode", this.$session.get("CustCode"));

      formData.append("image", file);
      var dataAxiosupload = {
        Method: "POST",
        Action: "Uploader",
        Token: this.$session.get("TokenNetPa"), // NetPa HANDOFF P1-4
        ArryfildValue: formData,
      };
      this.$PostFormData(dataAxiosupload).then((result) => {
        this.loadingRender = false;
        this.selectedName = "";
        this.$mySweetDefaultTost(result.title, result.msg, result.icon, 2000);
        this.$emit("Done", true);
      });
    },
    Remove(Id) {
      var axios = {
        Method: "POST",
        Action: "Uploader/Delete",
        Token: this.$session.get("TokenNetPa"), // NetPa HANDOFF P1-4
        ArryfildValue: { Id: Id },
      };
      this.$PostData(axios).then((result) => {
        this.$mySweetDefaultTost(result.title, result.msg, result.icon, 2000);
        this.$emit("Done", true);
      });
    },
    DeleteImage(Id) {
      this.$SweetQustion(
        "هشدار",
        "ایا از حذف این مدرک اطمینان دارید؟",
        "warning",
        "بله، حذف شود",
        "خیر",
        Id,
        this.Remove,
        this.Cancel,
      );
    },
    CheckExtension(FileName) {
      var ex = FileName.split(".").pop();
      return ["rar", "zip", "png", "jpg", "jpeg", "pdf"].includes(ex);
    },
    Cancel() {},
  },
};
</script>

<style scoped>
.netpa-dropzone {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  min-height: 120px;
  padding: 16px;
  color: #6b7b8e;
  font-family: inherit;
  background: #f9fbfc;
  border: 1px dashed #c9d5df;
  border-radius: 14px;
  cursor: pointer;
  transition:
    border-color 180ms ease,
    background 180ms ease,
    color 180ms ease;
}

.netpa-dropzone i {
  color: #29345f;
  font-size: 32px;
}

.netpa-dropzone:hover,
.netpa-dropzone.is-selected {
  color: #29345f;
  background: #edf7fb;
  border-color: #05b8c8;
}

.netpa-dropzone:focus-visible {
  outline: none;
  box-shadow: 0 0 0 4px rgba(5, 184, 200, 0.2);
}

.netpa-dropzone__text {
  max-width: 100%;
  font-size: 12px;
  font-weight: 700;
  overflow-wrap: anywhere;
}
</style>
